import { useSelector } from "react-redux";
import { RootState } from "@/store/store";

import DescriptionDetailsList from "@/shared/components/DescriptionDetailsList/DescriptionDetailsList";

export default function ScheduleAppointmentPatientInfo() {
    const appointmentData = useSelector(
        (state: RootState) => state.appointments,
    );
    const { doctorId, chairNumber } = appointmentData.existtAppointment;

    return (
        <div className='edit_drawer_container_doctor_info drawer_item'>
            <DescriptionDetailsList
                title='Лікар'
                description={doctorId ? doctorId.name : "Лікаря видалено"}
                style={{ width: "auto", flex: 1, marginRight: 20 }}
            />
            <DescriptionDetailsList
                title='Крісло'
                description={chairNumber.toString()}
                style={{ width: 136 }}
            />
        </div>
    );
}
